var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17393_43217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5997 9.33942L10.2599 6.01251M10.2599 6.01251L6.93303 9.35226M10.2599 6.01251L10.2747 13.6792C10.2769 14.8381 10.278 15.4175 10.7381 16.0654C11.0437 16.4959 11.9223 17.0263 12.4456 17.0961C13.2332 17.2013 13.532 17.0448 14.1294 16.7316C16.7918 15.3363 18.6059 12.5438 18.5997 9.3298C18.5908 4.72743 14.8527 1.00366 10.2503 1.01252C5.64794 1.02138 1.92417 4.75952 1.93303 9.36188C1.93897 12.4464 3.61998 15.1363 6.11359 16.5723",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17393_43217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.249023 0.198486) rotate(-0.110297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload04);
export default __webpack_public_path__ + "static/media/upload-04.a74a9539711b290cb574199b1f367f58.svg";
export { ForwardRef as ReactComponent };